import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../src/firebase.js';
import { getCurrentUser } from '../data/auth.js';

export async function loadKycStatus(uid) {
    if (!uid) return { kycVerified: false };
    try {
        const snap = await getDoc(doc(db, 'users', uid));
        return { kycVerified: !!snap.data()?.kycVerified };
    } catch {
        return { kycVerified: false };
    }
}

export async function startStripeIdentityVerification() {
    const user = getCurrentUser();
    if (!user) throw new Error('Sign in to verify your identity.');

    const returnUrl = `${window.location.origin}/#page=fund&kyc=return`;
    const res = await fetch('/api/stripe-identity', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ uid: user.uid, returnUrl }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || 'Could not start verification');
    if (data.url) window.location.href = data.url;
    return data;
}

export async function refreshKycStatus(uid) {
    const res = await fetch('/api/stripe-identity/status', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ uid }),
    });
    const data = await res.json().catch(() => ({}));
    if (data.kycVerified && uid) {
        await setDoc(doc(db, 'users', uid), { kycVerified: true }, { merge: true });
    }
    return data;
}
